import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import UserAvatar from '../../Global/Avatars/UserAvatar';
import VerticalTextLockup from '../../Global/Typography/VerticalTextLockup';
import RadioInput from '../../Global/Forms/RadioInput';
import Button from '../../Global/Buttons/Button';
import Icon from '../../Global/Icons/Icon';
import LazyLoad from '../../Global/Loaders/LazyLoad';
import SpinLoader from '../../Global/Loaders/SpinLoader';

const LicenceeTableRow = ({ licencee, onLicenceChange, onDeleteClick, loading }) => {
  const {
    'user-id': userId,
    'first-name': firstName,
    'last-name': lastName,
    'email-address': emailAddress,
    'licence-type': licenceType,
    'user-profile-image': userProfileImage,
    'last-active-string': lastActiveString,
    isNew,
  } = licencee.attributes;

  const handleDeleteClick = (e) => {
    e.preventDefault();
    onDeleteClick(licencee);
  };

  const handleLicenceChange = (e) => {
    e.preventDefault();
    onLicenceChange(licencee, e.target.value);
  };

  const tableRowClass = classnames('licencee-table-row', {
    'bg-green--light': isNew,
  });

  return (
    <tr className={tableRowClass}>
      <td>
        <div className="d-flex align-items-center">
          <UserAvatar image={userProfileImage} classes="m-r-2 hidden-xs-down">
            {loading &&
              <LazyLoad posAbsolute>
                <SpinLoader black />
              </LazyLoad>
            }
          </UserAvatar>
          <VerticalTextLockup
            title={<a href={`/user/${userId}`}>{`${firstName} ${lastName}`}</a>}
            subtitle={<span className="hidden-xs-down">{emailAddress} (Last active: {lastActiveString})</span>}
          />
        </div>
      </td>
      <td>
        <div className="d-flex flex-column align-items-center">
          <RadioInput name={`${licencee.id}-licence-type`} value="standard" onChange={handleLicenceChange} checked={licenceType === 'standard'} disabled={loading} />
        </div>
      </td>
      <td>
        <div className="d-flex flex-column align-items-center">
          <RadioInput name={`${licencee.id}-licence-type`} value="premium" onChange={handleLicenceChange} checked={licenceType === 'premium'} disabled={loading} />
        </div>
      </td>
      <td>
        <div className="d-flex flex-column align-items-center">
          <Button onClick={handleDeleteClick} classes="delete-btn icon icon--s" faux><Icon name="remove-circle-outline" size="s" /></Button>
        </div>
      </td>
    </tr>
  );
};

LicenceeTableRow.propTypes = {
  licencee: PropTypes.object.isRequired,
  onLicenceChange: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default LicenceeTableRow;



// WEBPACK FOOTER //
// ./library/app/components/Account/LicenceManager/LicenceeTableRow.js